import { sendGTMEvent } from "@next/third-parties/google"

export const GTM_ID = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID

export const pageView = (url: string, facilityCode: string, mode: string) => {
    const dataLayer = {
        event: "pageView",
        page: url,
        facilityCode: facilityCode,
        mode: mode,
    }
    sendGTMEvent(dataLayer)
}
